'use client'

import Menu from '@component/menu'
import { useMenuContext } from '@component/menu/context'
import { ORDER_MAP } from '@config'
import useProgressRouter from '@hooks/useProgressRouter'
import IconSort from '@icon/house/sort.svg'
import { getSlug } from '@utils'
import classNames from 'classnames'
import { find, get, has, isEqual, map } from 'lodash-es'
import { useCallback, useMemo, useState } from 'react'
import { useHouseListContext } from '../../../../layout/context'
import { slugToQuery } from '../../../../utils'
import { PopupContent, getFilterRouter } from '../../base'

export default function SortButton() {

  const { state } = useHouseListContext()
  const routeParams = useMemo(() => slugToQuery(state).toString(), [state])
  const { type } = state
  const list = useMemo(() => ORDER_MAP[type], [type])
  const [order, setOrder] = useState(has(routeParams, 'order') ? routeParams.order : null)
  const orderLabel = useMemo(() => get(find(list, item => item.value === order), 'label'), [order, list])

  // 切换排序
  const { replaceRouter } = useProgressRouter()
  const clickHandle = useCallback(item => {
    return () => {
      setOrder(item.value)

      const { slug } = state
      const [url, newSlug] = getFilterRouter(state)(houseRoute => {
        houseRoute.order = item.value !== null ? getSlug(item.label, item.value) : null
      })
      if (!isEqual(slug, newSlug)) {
        replaceRouter(url)
      }
    }
  }, [state, setOrder, replaceRouter])
  return (
    <>
      <div className='inline-block'>
        <Menu
          right
          hover={false}
          popup={
            <PopupContent title='Sort by:' showButton={false}>
              <div className='space-y-10'>
                {
                  map(list, item => (
                    <div
                      onClick={clickHandle(item)}
                      className={classNames(
                        'text-sm h-50 flex items-center border rounded-sm px-10 cursor-pointer',
                        order === item.value ? 'text-primary border-primary bg-primary-light' : 'text-font'
                      )}
                      key={item.label}
                    >{item.label}</div>
                  ))
                }
              </div>
            </PopupContent>
          }
          width={375}
          contentClassName='rounded-md'
          fixedBg
        >
          <Span>{orderLabel}</Span>
        </Menu>
      </div>
    </>
  )
}

function Span({
  children
}) {
  const { visible } = useMenuContext()
  return (
    <div className={classNames('cursor-pointer text-base flex items-center gap-x-6 border border-transparent sm:h-36 sm:px-10 rounded-xl hover:bg-primary-light', { 'bg-primary-light !border-primary': visible })}>
      <IconSort className='w-20 h-20'></IconSort>
      <span className='hidden md:block'>Sort by:</span>
      <span className='text-primary'>{children}</span>
    </div>
  )
}
